import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { severityCss, severityLabelKey } from 'src/app/service-center/severity';

// Solid-filled tier pill (Critical / High / Medium / Low). The numeric severity
// is intentionally NOT shown here — the tier name carries the operational
// meaning in list contexts. `variant='list'` fixes the width to 76px (row grid);
// `variant='detail'` lets it size to content (drawer stats).
@Component({
  selector: 'app-severity-tag',
  template: `<span class="sev-tag" [class.fixed]="variant === 'list'" [ngClass]="cssClass">
    {{ labelKey | translate }}</span>`,
  styles: [`
    /* The house severity badge, so one Issue reads the same wherever it appears. */
    .sev-tag {
      display: inline-flex; align-items: center; justify-content: center;
      padding: 3px 12px; border-radius: 12px;
      font-size: 12px; font-weight: 600; letter-spacing: 0.3px;
      color: #fff; white-space: nowrap;
    }
    /* The sheet's severity column is this width too — see issue-row.component.scss. */
    .sev-tag.fixed { width: 76px; padding: 3px 0; }
    .sev-tag.sev-critical { background: var(--sc-sev-critical); }
    .sev-tag.sev-high     { background: var(--sc-sev-high); }
    /* White fails contrast on the yellow, so this one bucket carries its own ink. */
    .sev-tag.sev-medium   { background: var(--sc-sev-medium); color: var(--sc-sev-medium-text); }
    .sev-tag.sev-low      { background: var(--sc-sev-low); }
    .sev-tag.sev-none     { background: var(--sc-sev-none); }
  `],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SeverityTagComponent {
  @Input() severity = 0;
  @Input() variant: 'list' | 'detail' = 'list';

  get cssClass(): string { return severityCss(this.severity); }
  get labelKey(): string { return severityLabelKey(this.severity); }
}
